import { QUERY_KEYS } from "@/libraries/constant";
import type { CreateTeamFormSchema, UpdateTeamFieldSchema } from "@/schemas";
import type { teamService } from "@/services";
import type { PostCreateTeamResponseType, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useTeamMutation() {
	const create = useMutation<
		PostCreateTeamResponseType,
		ResError,
		CreateTeamFormSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_TEAM_CREATE],
	});

	const update = useMutation<any, ResError, UpdateTeamFieldSchema>({
		mutationKey: [QUERY_KEYS.MUTATE_TEAM_UPDATE],
	});

	const leave = useMutation<any, ResError, number>({
		mutationKey: [QUERY_KEYS.MUTATE_TEAM_LEAVE],
	});

	const assignCaseExternal = useMutation<
		Awaited<ReturnType<typeof teamService.assignCaseExternal>>,
		ResError,
		Parameters<typeof teamService.assignCaseExternal>[0],
		Awaited<ReturnType<typeof teamService.assignCaseExternal>>
	>({
		mutationKey: [QUERY_KEYS.MUTATE_TEAM_CASE_EXTERNAL],
	});

	return {
		create,
		update,
		leave,
		assignCaseExternal,
	};
}

export default useTeamMutation;
